import React from 'react'

import RadioSection from '../RadioSection'
import Footer from '../Footer'
import { Form } from '@s4l/ds'

import styles from '../styles.module.css'

function FormPlaceholder() {
  return (
    <div className={styles.container}>
      <Form>
        <main className={styles.main}>
          <RadioSection.Placeholder />
          <RadioSection.Placeholder />
          <RadioSection.Placeholder />
        </main>
        <Footer.Placeholder />
      </Form>
    </div>
  )
}

FormPlaceholder.displayName = 'RoomConfigurator.Form.Placeholder'

export default FormPlaceholder
